import { Prop, Vue } from "vue-property-decorator";
import { ConfigurationFields } from "./declarations";

export default abstract class ConfigurationField extends Vue
  implements ConfigurationFields.ConfigurationField {
  @Prop({ default: "" }) protected value!: any;
  @Prop()
  protected configuration!: ConfigurationFields.FieldCustomConfiguration;
  protected abstract defaultConfiguration: ConfigurationFields.FieldCustomConfiguration;

  protected input(value: any) {
    this.$emit("input", value);
  }

  public get config() {
    const parsedConfig = { ...this.configuration };
    return { ...this.defaultConfiguration, ...parsedConfig };
  }
}
